import * as React from "react";
import { RouterLayoutBasic } from "..";
export const RouterLayoutBasicPadding = React.memo(function RouterLayoutBasicPadding({ children, ctx }) {
    return React.createElement(RouterLayoutBasic, { children: children, ctx: ctx, padding: true });
});
//# sourceMappingURL=RouterLayoutBasicPadding.js.map